export default "__VITE_ASSET__CeWvFRYq__"